/* tslint:disable */
/* eslint-disable */
/**
 * EH Commissioning WebAPI 1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import { Area, AreaFromJSON, AreaFromJSONTyped, AreaToJSON } from "./Area";
import { Attachment, AttachmentFromJSON } from "./Attachment";
import { ErrorResponse, ErrorResponseFromJSON, ErrorResponseFromJSONTyped, ErrorResponseToJSON } from "./ErrorResponse";

/**
 *
 * @export
 * @interface AreaListControllerResponse
 */
export interface AreaListControllerResponse {
  /**
   *
   * @type {Array<Area>}
   * @memberof AreaListControllerResponse
   */
  data?: Array<Area> | null;
  /**
   *
   * @type {ErrorResponse}
   * @memberof AreaListControllerResponse
   */
  error?: ErrorResponse;
}

export interface AttachmentListControllerResponse {
  /**
   *
   * @type {Array<Attachment>}
   * @memberof AttachmentListControllerResponse
   */
  data?: Array<Attachment> | null;
  /**
   *
   * @type {ErrorResponse}
   * @memberof AttachmentListControllerResponse
   */
  error?: ErrorResponse;
}

export function AreaListControllerResponseFromJSON(json: any): AreaListControllerResponse {
  return AreaListControllerResponseFromJSONTyped(json, false);
}

export function ProjectAttachmentListControllerResponseFromJSON(json: any): any {
  return AttachmentListControllerResponseFromJSONTyped(json, false);
}

export function ProjectAreaAttachmentListControllerResponseFromJSON(json: any): any {
  return AttachmentListControllerResponseFromJSONTyped(json, false);
}

export function ProjectTagAttachmentListControllerResponseFromJSON(json: any): any {
  return AttachmentListControllerResponseFromJSONTyped(json, false);
}

export function ProjectAreaImageListControllerResponseFromJSON(json: any): any {
  return AttachmentListControllerResponseFromJSONTyped(json, false);
}

export function AreaListControllerResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): AreaListControllerResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    data: !exists(json, "data")
      ? undefined
      : json["data"] === null
      ? null
      : (json["data"] as Array<any>).map(AreaFromJSON),
    error: !exists(json, "error") ? undefined : ErrorResponseFromJSON(json["error"]),
  };
}

export function AttachmentListControllerResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): AttachmentListControllerResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    data: !exists(json, "data")
      ? undefined
      : json["data"] === null
      ? null
      : (json["data"] as Array<any>).map((x) => AttachmentFromJSON(x)),
    error: !exists(json, "error") ? undefined : ErrorResponseFromJSON(json["error"]),
  };
}

export function AreaListControllerResponseToJSON(value?: AreaListControllerResponse | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    data:
      value.data === undefined ? undefined : value.data === null ? null : (value.data as Array<any>).map(AreaToJSON),
    error: ErrorResponseToJSON(value.error),
  };
}
